<template>
 <div class="view-container">
    <div style="float: right;">
      <label class="cont" for="updateCheckbox">
        <input type="checkbox" id="updateCheckbox" v-model="data.isPCUpdate" @change="updateChange">
        <span class="checkmark"></span>
        <p class="semi-bold checkbox-title">PC update</p>
      </label>
    </div>
    <div style="display: flex; width: 100%; justify-content: space-between;">
     <div class="vertical pr-2" style="flex-grow: 1">
       <label class="extra-bold header-color mb-3" style="font-size: 24px;">Farm info</label>
       <TextField v-model="data.farmName" ref="farmInfoNameInput" :maxLength="30" inputClass="form-input" title="Farm Name"
          @onChange="isFarmInfoNameValid" :errorMode="connectionFarmInfoError.farmName"/>
       <TextField v-model="data.farmCountry" ref="farmInfoCountryInput" :maxLength="255" inputClass="form-input" title="Farm Country"
          @onChange="isFarmInfoCountryValid" :errorMode="connectionFarmInfoError.farmCountry"/>
       <TextField v-model="data.farmAddress" ref="farmInfoAddressInput" :maxLength="255" inputClass="form-input" title="Farm Address"
          @onChange="isFarmInfoAddressValid" :errorMode="connectionFarmInfoError.farmAddress"/>
     </div>
     <div class="vertical pr-2 pl-2" style="flex-grow: 1">
       <label class="extra-bold header-color mb-3" style="font-size: 24px;">Contact Person</label>
       <TextField v-model="data.contactPersonFirstName" ref="contactPersonFirstNameInput" :maxLength="255" inputClass="form-input" title="First Name"
          @onChange="isContactPersonFirstNameValid" :errorMode="connectionContactPersonError.firstName"/>
       <TextField v-model="data.contactPersonLastName" ref="contactPersonLastNameInput" :maxLength="255" inputClass="form-input" title="Last Name"
          @onChange="isContactPersonLastNameValid" :errorMode="connectionContactPersonError.lastName"/>
       <TextField v-model="data.contactPersonEmail" ref="contactPersonEmailInput" :maxLength="255" inputClass="form-input" title="Email"
          @onChange="isContactPersonEmailValid" :errorMode="connectionContactPersonError.email"/>
       <TextField v-model="data.contactPersonPhoneNumber" ref="contactPersonPhoneNumberInput" :maxLength="255" inputClass="form-input" title="Phone Number"
          valueType="number" @onChange="isContactPersonPhoneNumberValid" :errorMode="connectionContactPersonError.phoneNumber"/>
       <TextField v-model="data.contactPersonResponsibility" ref="contactPersonResponsibilityInput" :maxLength="255" inputClass="form-input" title="Responsibility"
          @onChange="isContactPersonResponsibilityValid" :errorMode="connectionContactPersonError.responsibility"/>
     </div>
     <div class="vertical pl-2" style="flex-grow: 1">
       <label class="extra-bold header-color mb-3" style="font-size: 24px;">Farm Owner</label>
       <TextField v-model="data.farmOwnerFirstName" ref="farmOwnerFirstNameInput" :maxLength="255" inputClass="form-input" title="First Name"
          @onChange="isFarmOwnerFirstNameValid" :errorMode="connectionFarmOwnerError.firstName"/>
       <TextField v-model="data.farmOwnerLastName" ref="farmOwnerLastNameInput" :maxLength="255" inputClass="form-input" title="Last Name"
          @onChange="isFarmOwnerLastNameValid" :errorMode="connectionFarmOwnerError.lastName"/>
       <TextField v-model="data.farmOwnerEmail" ref="farmOwnerEmailInput" :maxLength="255" inputClass="form-input" title="Email"
          @onChange="isFarmOwnerEmailValid" :errorMode="connectionFarmOwnerError.email"/>
       <TextField v-model="data.farmOwnerPhoneNumber" ref="farmOwnerPhoneNumberInput" :maxLength="255" inputClass="form-input" title="Phone Number"
         valueType="number" @onChange="isFarmOwnerPhoneNumberValid" :errorMode="connectionFarmOwnerError.phoneNumber"/>
       <TextField v-model="data.farmOwnerResponsibility" ref="farmOwnerResponsibilityInput" :maxLength="255" inputClass="form-input" title="Responsibility"
          @onChange="isFarmOwnerResponsibilityValid" :errorMode="connectionFarmOwnerError.responsibility"/>
       <Button title="Save" buttonClass='save-button semi-bold w-100 mt-4' @onClick="save" />
     </div>
   </div>
 </div>
</template>

<script>
import TextField from '@/components/TextField'
import Button from '@/components/Button'
import { getContactInfo, updateContactInfo, updatePcUpdate} from '@api'
import Modal from '@/components/Modal'

export default {
 props:['systemName', 'systemId'],
 components: {
   TextField,
   Button
 },
 mounted() {
   this.getData();
 },
 methods: {
   getData: async function(){
      let systemId = this.$route.params.systemId;
      let data = await getContactInfo(systemId);

      if (data.farmName === undefined) {
      this.data = new Object();
      this.data.farmName = '';
      this.data.farmCountry = '';
      this.data.farmAddress = '';
      this.data.contactPersonFirstName = '';
      this.data.contactPersonLastName = '';
      this.data.contactPersonEmail = '';
      this.data.contactPersonPhoneNumber = '';
      this.data.contactPersonResponsibility = '';
      this.data.farmOwnerFirstName = '';
      this.data.farmOwnerLastName = '';
      this.data.farmOwnerEmail = '';
      this.data.farmOwnerPhoneNumber = '';
      this.data.farmOwnerResponsibility = '';
      this.data.isPCUpdate = true;
      } else {
        this.data = data;
      }
   },

   isFarmInfoNameValid(value) {
     if(value.length > 30){
       this.connectionFarmInfoError.farmName = 'Farm name is too long. Maximum 30 characters';
     }
     else {
       this.connectionFarmInfoError.farmName = '';
       this.data.farmName = value;
     }
   },
   isFarmInfoCountryValid(value) {
     if(value.length > 255){
       this.connectionFarmInfoError.farmCountry = 'Farm country is too long. Maximum 255 characters';
     }
     else {
       this.connectionFarmInfoError.farmCountry = '';
       this.data.farmCountry = value;
     }
   },
   isFarmInfoAddressValid(value){
     if(value.length > 255){
       this.connectionFarmInfoError.farmAddress = 'Farm address is too long. Maximum 255 characters';
     }
     else {
       this.connectionFarmInfoError.farmAddress = '';
       this.data.farmAddress = value;
     }
   },
   isContactPersonFirstNameValid(value){
     if(value.length > 255){
       this.connectionContactPersonError.firstName = 'Contact person first name is too long. Maximum 255 characters';
     }
     else {
       this.connectionContactPersonError.firstName = '';
       this.data.contactPersonFirstName= value;
     }
   },
   isContactPersonLastNameValid(value){
     if(value.length > 255){
       this.connectionContactPersonError.lastName = 'Contact person last name is too long. Maximum 255 characters';
     }
     else {
       this.connectionContactPersonError.lastName = '';
       this.data.contactPersonLastName= value;
     }
   },
   isContactPersonEmailValid(value){
     value = value.trim()
     if(!this.emailRegex.test(value)){
       this.connectionContactPersonError.email = 'Contact person e-mail invalid format';
     }
     else {
       this.connectionContactPersonError.email = '';
       this.data.contactPersonEmail= value;
     }
   },
   isContactPersonPhoneNumberValid(value){
     if(value.length > 255){
       this.connectionContactPersonError.phoneNumber = 'Contact person phone number is too long. Maximum 255 characters';
     }
     else {
       this.connectionContactPersonError.phoneNumber = '';
       this.data.contactPersonPhoneNumber= value;
     }
   },
   isContactPersonResponsibilityValid(value){
     if(value.length > 255){
       this.connectionContactPersonError.responsibility = 'Contact person responsibility is too long. Maximum 255 characters';
     }
     else {
       this.connectionContactPersonError.responsibility = '';
       this.data.contactPersonResponsibility= value;
     }
   },
   isFarmOwnerFirstNameValid(value){
     if(value.length > 255){
       this.connectionFarmOwnerError.firstName = 'Farm owner first name is too long. Maximum 255 characters';
     }
     else {
       this.connectionFarmOwnerError.firstName = '';
       this.data.farmOwnerFirstName = value;
     }
   },
   isFarmOwnerLastNameValid(value){
     if(value.length > 255){
       this.connectionFarmOwnerError.lastName = 'Farm owner last name is too long. Maximum 255 characters';
     }
     else {
       this.connectionFarmOwnerError.lastName = '';
       this.data.farmOwnerLastName = value;
     }
   },
   isFarmOwnerEmailValid(value){
     value = value.trim()
     if(!this.emailRegex.test(value)){
       this.connectionFarmOwnerError.email = 'Farm owner e-mail invalid format';
     }
     else {
       this.connectionFarmOwnerError.email = '';
       this.data.farmOwnerEmail = value;
     }
   },
   isFarmOwnerPhoneNumberValid(value){
     if(value.length > 255){
       this.connectionFarmOwnerError.phoneNumber = 'Farm owner phone number is too long. Maximum 255 characters';
     }
     else {
       this.connectionFarmOwnerError.phoneNumber = '';
       this.data.farmOwnerPhoneNumber = value;
     }
   },
   isFarmOwnerResponsibilityValid(value){
     if(value.length > 255){
       this.connectionFarmOwnerError.responsibility = 'Farm owner responsibility is too long. Maximum 255 characters';
     }
     else {
       this.connectionFarmOwnerError.responsibility = '';
       this.data.farmOwnerResponsibility = value;
     }
   },
   save(){
     this.checkFarmInfo();
     this.checkContactPerson();
     this.checkFarmOwner();

     if(this.connectionFarmInfoError.farmName.length === 0 && this.connectionFarmInfoError.farmCountry.length === 0 && this.connectionFarmInfoError.farmAddress.length === 0
          && this.connectionFarmOwnerError.firstName.length === 0 && this.connectionFarmOwnerError.lastName.length === 0 && this.connectionFarmOwnerError.email.length === 0 && this.connectionFarmOwnerError.responsibility.length === 0 && this.connectionFarmOwnerError.phoneNumber.length === 0
          && this.connectionContactPersonError.firstName.length === 0 && this.connectionContactPersonError.lastName.length === 0 && this.connectionContactPersonError.email.length === 0 && this.connectionContactPersonError.responsibility.length === 0 && this.connectionContactPersonError.phoneNumber.length === 0){
            this.data.systemId = this.$route.params.systemId;
            // console.log(this.data);
            updateContactInfo(this.data);
            this.$store.dispatch('show_confirm');
     }
   },
   checkFarmInfo(){
    //  console.log(this.data);
     if(this.data.farmName.length === 0) this.connectionFarmInfoError.farmName = "Farm info name is required";
     if(this.data.farmCountry.length === 0) this.connectionFarmInfoError.farmCountry = "Farm info country is required";
     if(this.data.farmAddress.length === 0) this.connectionFarmInfoError.farmAddress = "Farm info address is required";
   },
   checkContactPerson(){
     if(this.data.contactPersonFirstName.length === 0) this.connectionContactPersonError.firstName = "Contact person first name is required";
     if(this.data.contactPersonLastName.length === 0) this.connectionContactPersonError.lastName = "Contact person last name is required";
     if(this.data.contactPersonEmail.length === 0) this.connectionContactPersonError.email = "Contact person e-mail is required";
     if(isNaN(this.data.contactPersonPhoneNumber) ||this.data.contactPersonPhoneNumber === '') this.connectionContactPersonError.phoneNumber = "Contact person phone number is required";
     if(this.data.contactPersonResponsibility.length === 0) this.connectionContactPersonError.responsibility = "Contact person responsibility is required";
   },
   checkFarmOwner(){
     if(this.data.farmOwnerFirstName.length === 0) this.connectionFarmOwnerError.firstName = "Farm owner first name is required";
     if(this.data.farmOwnerLastName.length === 0) this.connectionFarmOwnerError.lastName = "Farm owner last name is required";
     if(this.data.farmOwnerEmail.length === 0) this.connectionFarmOwnerError.email = "Farm owner e-mail is required";
     if(isNaN(this.data.farmOwnerPhoneNumber) || this.data.farmOwnerPhoneNumber === '') this.connectionFarmOwnerError.phoneNumber = "Farm owner phone number is required";
     if(this.data.farmOwnerResponsibility.length === 0) this.connectionFarmOwnerError.responsibility = "Farm owner responsibility is required";
   },
   async updateChange() {
     await updatePcUpdate(this.data.systemId, this.data.isPCUpdate);
    //  console.log("asd123");
   }
 },
 data() {
   return{
     Languages: [],
     data: {},
     emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
     connectionFarmInfoError: {
       farmName: "",
       farmCountry: "",
       farmAddress: "",
     },
     connectionContactPersonError: {
       firstName: "",
       lastName: "",
       email: "",
       phoneNumber: "",
       responsibility: ""
     },
     connectionFarmOwnerError: {
       firstName: "",
       lastName: "",
       email: "",
       phoneNumber: "",
       responsibility: ""
     }
   }
 },
}
</script>

<style scoped>
  .checkbox-title {
      margin-left: 10px;
      margin-bottom: 0px;
      line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/ContactForm.vue